import classNames from 'classnames';

export const FancyDollarDisplay = ({
  value,
  wholeClassName,
  decimalClassName,
}: {
  value: string;
  wholeClassName?: string;
  decimalClassName?: string;
}) => {
  const [whole, decimal] = value.split('.');

  return (
    <div className="font-aeonikMedium">
      <span className={classNames('text-cf-white', wholeClassName)}>{whole}.</span>
      <span className={classNames('text-12 text-cf-light-2', decimalClassName)}>{decimal}</span>
    </div>
  );
};
